import React,{useState,useEffect,useRef} from 'react'
import {Row, Col, Table} from 'antd';
import * as Home from '@/common/api/home'
import * as echarts from 'echarts';
function DeviceSummaryModal(props) {
    const [state, setstate] = useState('')
    const modalDataRef = useRef()
    const [obj,setObj] = useState({})
    const [dataQueryType, setDataQueryType] = useState(1)
    const [columns, setColumns] = useState([
        {
            title: '排名',
            dataIndex: 'name',
            align: 'center',
            width: 50,
            render: (text, record, index) => {return index+1}
        },
        {
            title: '设备编码',
            dataIndex: 'code',
            align: 'center',
            width: 130
        },
        {
            title: '片区',
            dataIndex: 'areas',
            align: 'center',
            width: 130
        },
        {
            title: '设备类型',
            dataIndex: 'apparatusType',
            align: 'center',
            width: 150
        },
        {
            title: '告警次数',
            dataIndex: 'alertNum',
            align: 'center',
            width: 80
        }
    ])
    let [data, setData] = useState([
        // {
        //     code: '临CDFY00901',
        //     areas: '合作区',
        //     apparatusType: '方圆',
        //     alertNum: '100'
        // }
    ])
    const close = () => {
        props.subClick('NoPopup', 'NoFilterbg')
        setstate(2)
    }
    // 获取饼状图所需数据
    const handleSummaryPieList = () => {
        Home.getTypeData({moduleKey:'equipmentSummary', dataQueryType: dataQueryType}).then(res => {
            if (res.code === 0 && res.data[0]) {
                modalDataRef.current = {...res.data[0].data}
                modalDataRef.current.summaryNum.map(item => {
                    if (item.supplierName === '天龙中闽') {
                        item.type = '0'
                    } else if (item.supplierName === '天津耀通') {
                        item.type = '3'
                    } else if (item.supplierName === '深圳恒星') {
                        item.type = '2'
                    }
                    item.name = item.supplierName
                    item.num = Number(item.faultNum)
                    item.count = Number(item.deviceNum)
                    return item
                })
                modalDataRef.current.alertRank.map(item => {
                    item.code = item.deviceSn
                    item.areas = item.areaName
                    item.apparatusType = item.typeName
                    item.alertNum = item.num
                })
                setData(modalDataRef.current.alertRank)
                setObj(modalDataRef.current)
                data =  modalDataRef.current.summaryNum
            }
        })
        // const data = [
        //     {
        //         type: '0',
        //         name: '天龙',
        //         num: 1600,
        //         count: 1743
        //     },
        //     {
        //         type: '1',
        //         name: '方圆',
        //         num: 206,
        //         count: 213
        //     },
        //     {
        //         type: '2',
        //         name: '恒星',
        //         normalNum: 1685,
        //         exceptionNum: 58,
        //         count: 1743
        //     },
        //     {
        //         type: '3',
        //         name: '耀通',
        //         normalNum: 1685,
        //         exceptionNum: 58,
        //         count: 1743
        //     }
        // ]
        // const data = modalDataRef.current.summaryNum
    }
    // 通过数据配置饼状图Echarts
    const initSummaryPieEcharts = (data) => {
        const options = {
            series: [{
                name: 'circle',
                type: 'pie',
                clockWise: true,
                radius: ['60%', '64%'],
                labelLine: {
                    show: false
                },
                data: [{
                    label: {
                        show: true,
                        fontSize: 28,
                        fontStyle: 'normal',
                        color:'white'
                    },
                    labelLine: {
                        show: true
                    },
                    lineStyle: {
                        normal: {}
                    },
                    itemStyle: {normal:{}}
                },{
                    value: 100,
                    itemStyle: {
                        normal: {
                            color: 'rgb(17,40,78)'
                        }
                    }
                }]
            }]
        }
        data.forEach(item => {
            if (item.type === '0') {
                const option1 = {...options}
                option1.title = {
                    text: item.name,
                    subtext: `设备总数：${item.count}个\n故障设备：${item.num}个`,
                    x: 'center',
                    y: 'center',
                    top: 140,
                    textStyle: {
                        fontWeight: 'normal',
                        color: 'rgb(254,210,37)',
                        fontSize: '24'
                    },
                    subtextStyle: {
                        fontWeight: 'normal',
                        color: 'white'
                        // fontSize: '24'
                    }
                }
                option1.series['0'].data['0'].value = item.num
                option1.series['0'].data['0'].itemStyle = {
                    normal: {
                        color: 'rgb(254,210,37)',
                        shadowBlur: 20,
                        shadowColor: 'rgb(254,210,37)'
                    }
                }
                option1.series['0'].data['0'].label.color = 'rgb(254,210,37)'
                option1.series['0'].data['0'].name = `${item.num <= 0 ? 0 : (Math.round(item.num / item.count * 10000) / 100.00)}%`
                option1.series['0'].data['1'].value = item.count - item.num
                option1.series['0'].data['0'].lineStyle.normal.color = 'rgb(254,210,37)'
                const summaryPie1 = echarts.init(document.getElementById('summaryPie1'))
                summaryPie1.setOption(option1, { noMerge: false })
                summaryPie1.resize({ width: '350px', height: '338px' })
            } else if(item.type === '2'){
                const option3 = {...options}
                option3.title = {
                    text: item.name,
                    subtext: `设备总数：${item.count}条\n故障设备：${item.num}条`,
                    x: 'center',
                    y: 'center',
                    top: 140,
                    textStyle: {
                        fontWeight: 'normal',
                        color: 'rgb(30,182,254)',
                        fontSize: '24'
                    },
                    subtextStyle: {
                        fontWeight: 'normal',
                        color: 'white'
                        // fontSize: '24'
                    }
                }
                option3.series['0'].data['0'].value = item.num
                option3.series['0'].data['0'].itemStyle = {
                    normal: {
                        color: 'rgb(30,182,254)',
                        shadowBlur: 20,
                        shadowColor: 'rgb(30,182,254)'
                    }
                }
                option3.series['0'].data['0'].label.color = 'rgb(30,182,254)'
                option3.series['0'].data['0'].name = `${item.num <= 0 ? 0 : (Math.round(item.num / item.count * 10000) / 100.00)}%`
                option3.series['0'].data['1'].value = item.count - item.num
                option3.series['0'].data['0'].lineStyle.normal.color = 'rgb(30,182,254)'
                const summaryPie3 = echarts.init(document.getElementById('summaryPie3'))
                summaryPie3.setOption(option3, { noMerge: false })
                summaryPie3.resize({ width: '350px',height: '338px' })
            } else if (item.type==='3') {
                const option4 = {...options}
                option4.title = {
                    text: item.name,
                    subtext: `设备总数：${item.count}条\n故障设备：${item.num}条`,
                    x: 'center',
                    y: 'center',
                    top: 140,
                    textStyle: {
                        fontWeight: 'normal',
                        color: '#f32f00',
                        fontSize: '24'
                    },
                    subtextStyle: {
                        fontWeight: 'normal',
                        color: 'white'
                        // fontSize: '24'
                    }
                }
                option4.series['0'].data['0'].value = item.num
                option4.series['0'].data['0'].itemStyle = {
                    normal: {
                        color: '#f32f00',
                        shadowBlur: 20,
                        shadowColor: '#f32f00'
                    }
                }
                option4.series['0'].data['0'].label.color = '#f32f00'
                option4.series['0'].data['0'].name = `${item.num <= 0 ? 0 : (Math.round(item.num / item.count * 10000) / 100.00)}%`
                option4.series['0'].data['1'].value = item.count - item.num
                option4.series['0'].data['0'].lineStyle.normal.color = '#f32f00'
                const summaryPie4 = echarts.init(document.getElementById('summaryPie4'))
                summaryPie4.setOption(option4, { noMerge: false })
                summaryPie4.resize({ width: '350px',height: '338px' })
            }
        })
    }
    // 通过数据配置柱状图
    const initSummaryBarEcharts = (data) => {
        const xAxis_data = []
        const series_data = []
        data.forEach(item => {
            xAxis_data.push(item.name)
            series_data.push(item.num)
        })
        const option = {
            title: {
                text: '设备故障数量',
                textStyle: {
                    color: 'rgb(32, 194, 248)',
                    fontStyle: 'normal',
                    fontWeight: 'normal',
                    fontSize: 24
                },
                x: 'center'
            },
            tooltip: {
                trigger: 'axis',
                backgroundColor: 'rgb(37,44,53)',
                borderColor: 'rgb(37,44,53)',
                textStyle: {
                    color: 'white'
                },
                formatter: function (params) {
                    return `本月${params[0].name}故障数量：${params[0].value}`
                }
            },
            grid: {
                left: '15%',
                bottom: '10%'
            },
            xAxis: {
                type: 'category',
                data: xAxis_data,
                axisLabel: {
                    margin: 10,
                    color: '#C9C9C9',
                    textStyle: {
                        fontSize: 12
                    }
                },
                axisLine: {
                    lineStyle: {
                        color: 'white'
                    }
                },
                axisTick: {
                    show: true
                },
                splitLine: {
                    show: false
                }
            },
            yAxis: {
                type: 'value',
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: 'white'
                    }
                },
                axisTick: {
                    show: true
                },
                splitLine: {
                    show: false
                }
            },
            series: [{
                data: series_data,
                type: 'bar',
                barWidth: '50',
                itemStyle: {
                    normal: {
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgb(56,121,206)'
                            },
                            {
                                offset: 1,
                                color: 'rgb(80,234,248)'
                            }
                        ])
                    }
                },
                label: {
                    normal: {
                        show: false,
                        fontSize: 16,
                        fontWeight: 'bold',
                        color: '#333',
                        position: 'top'
                    }
                }
            }]
        }
        const summaryBar = echarts.init(document.getElementById('summaryBar'))
        summaryBar.setOption(option, { noMerge: false })
        summaryBar.resize({ width:'465px',height: '300px' })
    }
    // 获取线型图数据
    const handleSummaryLineList = () => {
        const data = [
            {
                day: 1,
                num: 15
            },
            {
                day: 2,
                num: 5
            },
            {
                day: 3,
                num: 8
            },
            {
                day: 4,
                num: 11
            },
            {
                day: 5,
                num: 19
            },
            {
                day: 6,
                num: 2
            },
            {
                day: 7,
                num: 10
            },
            {
                day: 8,
                num: 6
            },
            {
                day: 9,
                num: 3
            },
            {
                day: 10,
                num: 11
            },
            {
                day: 11,
                num: 14
            },
            {
                day: 12,
                num: 15
            },
            {
                day: 13,
                num: 4
            },
            {
                day: 14,
                num: 7
            },
            {
                day: 15,
                num: 19
            },
            {
                day: 16,
                num: 20
            },
            {
                day: 17,
                num: 12
            },
            {
                day: 18,
                num: 11
            },
            {
                day: 19,
                num: 5
            },
            {
                day: 20,
                num: 3
            },
            {
                day: 21,
                num: 2
            },
            {
                day: 22,
                num: 15
            },
            {
                day: 23,
                num: 14
            },
            {
                day: 24,
                num: 10
            },
            {
                day: 25,
                num: 3
            },
            {
                day: 26,
                num: 15
            },
            {
                day: 27,
                num: 9
            },
            {
                day: 28,
                num: 19
            },
            {
                day: 30,
                num: 20
            },
            {
                day: 31,
                num: 15
            }
        ]
        initSummaryLineEcharts(data)
    }
    // 通过数据配置线型图
    const initSummaryLineEcharts = (data) => {
        const xAxis_data = []
        const series_data = []
        data.forEach(item => {
            xAxis_data.push(item.day)
            series_data.push(item.num)
        })
        const option ={
            title: {
                text: '本区工单数量统计',
                textStyle: {
                    color: 'rgb(32, 194, 248)',
                    fontStyle: 'normal',
                    fontWeight: 'normal',
                    fontSize: 24
                },
                x: 'center'
            },
            tooltip: {
                trigger: 'axis',
                backgroundColor: 'rgb(37,44,53)',
                borderColor: 'rgb(37,44,53)',
                textStyle: {
                    color: 'white'
                },
                formatter: function (params) {
                    return `本月${params[0].name}号开启数量：${params[0].value}`
                }
            },
            grid: {
                left: '2%',
                bottom: '10%'
            },
            xAxis: {
                type: 'category',
                boundaryGap: false,
                data: xAxis_data,
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: 'rgb(47,90,145)'
                    }
                }
            },
            yAxis: {
                type: 'value',
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: 'rgb(47,90,145)'
                    }
                },
                splitLine: {
                    show: true,
                    lineStyle: {
                        color: 'rgb(12,40,76)'
                    }
                }
            },
            series: [{
                data: series_data,
                type: 'line',
                areaStyle: {}
            }]
        }
        const summaryLine = echarts.init(document.getElementById('summaryLine'))
        summaryLine.setOption(option, { noMerge: false })
        summaryLine.resize({ width: '1119px',height: '300px' })
    }
    useEffect(() => {
        // handleSummaryLineList()
        switch (props.isShowAlertType) {
            case 'classification':
                setDataQueryType(1)
                break;
            case 'communication':
                setDataQueryType(2)
                break;
            case 'waterAffairs':
                setDataQueryType(3)
                break;
            default:
                break;
        }
        return () => {
        }
    }, [state])
    useEffect(() => {
        handleSummaryPieList()
    }, [dataQueryType])
    useEffect(() => {
        if (obj.summaryNum) {
            initSummaryPieEcharts(modalDataRef.current.summaryNum)
            initSummaryBarEcharts(modalDataRef.current.summaryNum)
        }
    }, [obj])
    return (
        <div className="box">
            <a onClick={()=>close()} className="popupClose"></a>
            <div className="summary">
                <div className="summaryTop clearfix">
                    <Row gutter={24} className="summaryBox">
                        <Col span={8}><div id="summaryPie1" className="summaryPie"></div></Col>
                        {/* <Col span={6}><div id="summaryPie2" className="summaryPie"></div></Col> */}
                        <Col span={8}><div id="summaryPie3" className="summaryPie"></div></Col>
                        <Col span={8}><div id="summaryPie4" className="summaryPie"></div></Col>
                    </Row>
                </div>
                <div className="summaryBottom">
                    <Row gutter={24} className="summaryBox">
                        <Col span={7} className="summaryBar" >
                            <div>
                                <div id="summaryBar"></div>
                            </div>
                        </Col>
                        <Col span={5}></Col>
                        <Col span={10} className="summaryLine" style={{paddingLeft: '50px',marginTop: '0'}}>
                            <p style={{width:'100%',textAlign:'center',fontSize:'23px',color:'rgb(32, 194, 248)'}}>设备告警排名(近三个月)</p>
                            <Table rowSelection={false} columns={columns} dataSource={data} pagination={false} size="small" bordered={true} />
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    )
}
export default DeviceSummaryModal